import { Component, Input } from '@angular/core';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TTranslationKey } from '../../features/translate/types';
import { iconMap } from '../../shared/enums/icon-map';

@Component({
  selector: 'pp-warning-box',
  templateUrl: './warning-box.component.html',
  styleUrls: ['./warning-box.component.scss'],
  standalone: false,
})
export class WarningBoxComponent {
  @Input() ppOpeningMessageKey: TTranslationKey;
  @Input() ppClosingMessageKey: TTranslationKey;
  @Input() ppWarningMessages: string[];
  @Input() ppIconPath: EIconPath = EIconPath.ICON_BADGE_WARNING_18;
  @Input() ppLevel: 'warning' | 'error' | 'info' = 'warning';
  iconMap = iconMap;

  EIconPath = EIconPath;
}
